export default "__VITE_ASSET__Cx0RQ6z___"